export const SET_DATA_SOURCES = 'SET_DATA_SOURCES'
export const SET_AUDIENCE_SIZE = 'SET_AUDIENCE_SIZE'
export const SET_TOP_TSP = 'SET_TOP_TSP'
export const SET_TOP_SOCIAL_AFFINITY = 'SET_TOP_SOCIAL_AFFINITY'
export const SET_REACH = 'SET_REACH'

export default {
  [SET_TOP_TSP] (state, value) {
    state.canvas.topTsp = value
  },
  [SET_TOP_SOCIAL_AFFINITY] (state, value) {
    state.canvas.topSocialAffinity = value
  },
  [SET_REACH] (state, value) {
    state.canvas.reach = value
  },
  [SET_DATA_SOURCES] (state, value) {
    state.dataSources = value
  },
  [SET_AUDIENCE_SIZE] (state, value) {
    state.canvas.audienceSize = value || 0
  }
}



// WEBPACK FOOTER //
// ./src/app/views/workbench/SM/store/mutations.js